var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-page__banner banner-block" }, [
    _c("div", {
      staticClass: "banner-block__style",
      domProps: { innerHTML: _vm._s(_vm.style) },
    }),
    _c("div", {
      staticClass: "banner-block__content",
      domProps: { innerHTML: _vm._s(_vm.html) },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }